import React, { useState, useEffect } from 'react';
import { Button, TextField, Card, CardContent, Typography, IconButton, Grid, Checkbox, FormControlLabel, Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Chip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import axiosInstance from '../common/axios';
import { useNavigate } from 'react-router-dom';
import warehouseService from '../service/warehouseService'; 
import FormInstructionBox from '../components/FormInstructionBox';

const cardStyle = {
  border: "1px solid",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  transition: "box-shadow 0.3s ease",
};


const daysOfWeek = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export default function WarehouseForm({ data, updateData, handleBack, finalSubmitData , handleSave,  mode }) {
  const [warehouses, setWarehouses] = useState(data || []);
  const [warehouse, setWarehouse] = useState(emptyWarehouse());
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
     const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
      const navigate = useNavigate();

  const [schedules, setSchedules] = useState(defaultSchedules());
  
  const addressInstructions = [
        "The **Warehouse Name** field is unique across all supplier profiles. Use unique name for all the Warehouse Names",
        "Dont delete the Warehouse after approval. It will be used for order fulfillments.",
        "The **Primary Warehouse** is the location you serve.",
        "If you have any questions or need more help. Please contact the System Administrator.WhatsApp or Phone: +91 999 464 1128",
        "When you create or edit Warehouse, After ADD WAREHOUSE, You much click on Update/Submit/Save.",
        "Click 'Edit and Update' to apply changes, or 'Cancel' to discard."
    ];
  
    function defaultSchedules() {
    return daysOfWeek.map((day) => ({
      day,
      open: false,
      openingTime: "09:00",
      closingTime: "18:00"
    }));
  }

  const [holidays, setHolidays] = useState([]);
  const [holidayInput, setHolidayInput] = useState("");

  const handleDayToggle = (day) => {
    setSchedules((prev) =>
      prev.map((s) =>
        s.day === day ? { ...s, open: !s.open } : s
      )
    );
  };

  const handleTimeChange = (day, field, value) => {
    setSchedules((prev) =>
      prev.map((s) =>
        s.day === day ? { ...s, [field]: value } : s
      )
    );
  };

  const handleAddHoliday = () => {
    if (holidayInput) {
      setHolidays([...holidays, holidayInput]);
      setHolidayInput("");
    }
  };
  
  function emptyWarehouse() {
    return {
         warehouseId: '', name: '', address: '', city: '', state: '', country: '', postalCode: '', phone: '', email: '',latitude: '',  longitude: '', schedules: [],
      holidays: [], primary: 0
    };
  }

  useEffect(() => {
    // Fetch dropdown data
 //   axiosInstance.get('/api/warehouses').then(res => setWarehouses(res.data));
      if(warehouses){
            updateData(warehouses);
        }
  }, [warehouses]);
  
  const checkWarehouseExistsLocal = async (name) => {
       const res = await warehouseService.checkWarehouseExists(name);
    // console.log("warehouse exist", res.data);
    return res.data;
  };
  
  const handleAddOrUpdate = async () => {
    
       if (
    !warehouse.name ||
    !warehouse.address ||
    !warehouse.city ||
    !warehouse.state ||
    !warehouse.country ||
    !warehouse.postalCode ||
    !warehouse.phone ||
    !warehouse.email
  ) {
    alert("Please fill in all required fields.");
    return; 
  }
    
    // check if the warehouse already exist
    const isexist = await checkWarehouseExistsLocal(warehouse.name);
        console.log("warehouse isexist", isexist);
    if(isexist){
       alert("Warehouse Name already exists. Please choose a different warehouse name!");
      return;
    }
    
      const updatedWarehouse = {
      ...warehouse,
      schedules: schedules,
      holidays: holidays,
        primary: Number(warehouse.primary) ? 1 : 0,
    };
    
    if (isEditing) {
      const updated = [...warehouses];
      updated[editingIndex] = updatedWarehouse;
      setWarehouses(updated);
      setIsEditing(false);
      setEditingIndex(null);
    } else {
      setWarehouses(prev => [...prev, updatedWarehouse]);
    }
    setWarehouse(emptyWarehouse());
     setSchedules(defaultSchedules());
    setHolidays([]);
      setIsUpdateDisabled(false);
  };

  const handleEdit = (index) => {
     const w = warehouses[index];
   // setWarehouse(w);
    setWarehouse({
      ...w,
      // ensure primary is normalized to 0/1
      primary: w.primary ? Number(w.primary) : 0,
    });
    setSchedules(w.schedules?.length ? w.schedules : defaultSchedules());
    setHolidays(w.holidays || []);
    setIsEditing(true);
    setEditingIndex(index);
  };

  const handleDelete = (index) => {
    
        const warehouseAtIndex = warehouses[index];
    
    if((mode && mode === "dashboard") && warehouseAtIndex?.warehouseId){
      
   if (window.confirm("Are you sure you want to delete this Warehouse?")) {
    try {
     warehouseService.deleteSupplierWarehouse(warehouseAtIndex.warehouseId);
      
    const updated = warehouses.filter((_, i) => i !== index); 
    setWarehouses(updated);
    if (isEditing && index === editingIndex) {
      setIsEditing(false);
      setEditingIndex(null);
      setWarehouse(emptyWarehouse());
    }
   
    } catch (err) {
      console.error("Error deleting warehouse:", err);
    }
   }
      
      
    }else{
    
    const updated = warehouses.filter((_, i) => i !== index); 
    setWarehouses(updated);
    if (isEditing && index === editingIndex) {
      setIsEditing(false);
      setEditingIndex(null);
      setWarehouse(emptyWarehouse());
    }
    }
  };
  
  const handleUpdate = () => {
    
    handleSave();
      setIsUpdateDisabled(true);
  };

  const handleFinish = () => {
      if(warehouses.length==0){
      alert("Add warehouse and then click finish! ");
      return;
    }
    updateData(warehouses);
    const submissionData = {
      ...finalSubmitData,
      warehouses: warehouses
    };

    axiosInstance.post('/api/suppliers', submissionData)
      .then(response => {
        alert('Supplier submitted successfully!');
           navigate('/supplierdashboard');
        console.log(response.data);
      })
      .catch((err) => {
      if (err.response) {
    let errorMsg = "Something went wrong!";

    if (typeof err.response.data === "string") {
      try {
        const parsed = JSON.parse(err.response.data);
        errorMsg = parsed.error || errorMsg;
      } catch {
        errorMsg = err.response.data;
      }
    } else if (err.response.data.error) {
      errorMsg = err.response.data.error;
    }

    alert(errorMsg +" if you still facing the same issue, Try to login again");
  } else {
    alert("Network error, Close and please to try to login again.");
  }
      });
 
    console.log('Final Supplier Submission Data:', submissionData);
  };

  return (
    <div className="space-y-4">
      {/* Warehouse List */}
      {warehouses.map((w, index) => (
        <>
        <Card key={index} variant="outlined"  style={{ ...cardStyle, borderColor: "#F44336" }}>
          <CardContent className="flex justify-between items-center">
            <div>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" , textTransform: "uppercase"}}>
                {w.name} {Number(w.primary) === 1 && <Chip label="Primary" size="small" color="primary" sx={{ ml: 1 }} />}
              </Typography>
              <Typography variant="subtitle1">{w.name}</Typography>
              <Typography variant="body2">
                {w.address}, {w.city}, {w.state}, {w.country} - {w.postalCode}
              </Typography>
                {w.schedules && (
                <Typography variant="caption" color="textSecondary">
                  Open Days: {w.schedules.filter(s => s.open).map(s => s.day).join(", ")}
                </Typography>
              )}
            </div>
            {!w.warehouseId && (

            <div>
              <IconButton onClick={() => handleEdit(index)}><Edit /></IconButton>
              <IconButton onClick={() => handleDelete(index)}><Delete /></IconButton>
            </div>
            )}
          </CardContent>
        </Card>
        <br/>
                </>
      ))}
        <br/>
      {/* Warehouse Form */}
       <input type="hidden" value={warehouse.warehouseId} onChange={e => setWarehouse({ ...warehouse, warehouseId: e.target.value })} required/>
      <TextField label="Warehouse Name" fullWidth value={warehouse.name} onChange={e => setWarehouse({ ...warehouse, name: e.target.value })} required/>
      <TextField label="Address" fullWidth value={warehouse.address} onChange={e => setWarehouse({ ...warehouse, address: e.target.value })} required />
      <TextField label="City" fullWidth value={warehouse.city} onChange={e => setWarehouse({ ...warehouse, city: e.target.value })} required />
      <TextField label="State" fullWidth value={warehouse.state} onChange={e => setWarehouse({ ...warehouse, state: e.target.value })} required/>
      <TextField label="Country" fullWidth value={warehouse.country} onChange={e => setWarehouse({ ...warehouse, country: e.target.value })} required />
      <TextField label="Postal Code" fullWidth value={warehouse.postalCode} onChange={e => setWarehouse({ ...warehouse, postalCode: e.target.value })} required />
      <TextField label="Phone" fullWidth value={warehouse.phone} onChange={e => setWarehouse({ ...warehouse, phone: e.target.value })} required />
      <TextField label="Email" fullWidth value={warehouse.email} onChange={e => setWarehouse({ ...warehouse, email: e.target.value })} required />
<TextField label="Latitude" fullWidth value={warehouse.latitude} onChange={e => setWarehouse({ ...warehouse, latitude: e.target.value })} required />
      <TextField label="Longitude" fullWidth value={warehouse.longitude} onChange={e => setWarehouse({ ...warehouse, longitude: e.target.value })} required />

      {/* Primary selector (radio) */}
      <FormControl component="fieldset" sx={{ mt: 1 }}>
        <FormLabel component="legend">Primary Warehouse</FormLabel>
        <RadioGroup
          row
          name="primary"
          value={String(warehouse.primary ?? 0)}
          onChange={(e) => setWarehouse({ ...warehouse, primary: Number(e.target.value) })}
        >
          <FormControlLabel value="1" control={<Radio />} label="Primary" />
          <FormControlLabel value="0" control={<Radio />} label="Secondary" />
        </RadioGroup>
      </FormControl>

        <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Typography variant="h6">Warehouse Availability</Typography>
      </Grid>

      {schedules.map((s) => (
        <Grid container item xs={12} key={s.day} spacing={1} alignItems="center">
          <Grid item xs={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={s.open}
                  onChange={() => handleDayToggle(s.day)}
                />
              }
              label={s.day}
            />
          </Grid>
          {s.open && (
            <>
              <Grid item xs={4}>
                <TextField
                  label="Opening Time"
                  type="time"
                  value={s.openingTime}
                  onChange={(e) =>
                    handleTimeChange(s.day, "openingTime", e.target.value)
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  label="Closing Time"
                  type="time"
                  value={s.closingTime}
                  onChange={(e) =>
                    handleTimeChange(s.day, "closingTime", e.target.value)
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </>
          )}
        </Grid>
      ))}

      {/* Holidays */}
      <Grid item xs={12}>
        <Typography>Holidays</Typography>
        <TextField
          type="date"
          value={holidayInput}
          onChange={(e) => setHolidayInput(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <Button onClick={handleAddHoliday}>Add Holiday</Button>
        <ul>
          {holidays.map((h, i) => (
            <li key={i}>{h}</li>
          ))}
        </ul>
      </Grid>
</Grid>
        
      <Button variant="outlined" onClick={handleAddOrUpdate}>
        {isEditing ? 'Update Warehouse' : 'Add Warehouse'}
      </Button>
 {!(mode && mode === "dashboard") ? (
   <>
      <div className="flex justify-between mt-4">
        <Button onClick={handleBack}>Back</Button>
        <Button variant="contained" onClick={handleFinish}>Finish</Button>
      </div>
  </>
   ) : ( 
          <>
                  <Button variant="contained" color="primary" disabled={isUpdateDisabled} onClick={handleUpdate}>
            Update
          </Button>
</>
         )}
         
                   <FormInstructionBox 
                instructions={addressInstructions} 
                title="Warehouse Details Guidelines" 
            />
         
    </div>
  );
}
